var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLgvish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72727 11.6364V8.72727H3.27273L5.45455 4.36364V7.27273H6.90909L4.72727 11.6364ZM1.45455 16C1.05455 16 0.712121 15.8576 0.427273 15.5727C0.142424 15.2879 0 14.9455 0 14.5455V1.45455C0 1.05455 0.142424 0.712121 0.427273 0.427273C0.712121 0.142424 1.05455 0 1.45455 0H8.72727C9.12727 0 9.4697 0.142424 9.75455 0.427273C10.0394 0.712121 10.1818 1.05455 10.1818 1.45455V14.5455C10.1818 14.9455 10.0394 15.2879 9.75455 15.5727C9.4697 15.8576 9.12727 16 8.72727 16H1.45455ZM1.45455 13.8182V14.5455H8.72727V13.8182H1.45455ZM1.45455 12.3636H8.72727V3.63636H1.45455V12.3636ZM1.45455 2.18182H8.72727V1.45455H1.45455V2.18182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgvish);
export default __webpack_public_path__ + "static/media/LGVISH.6b8e8387a4af1062343107ba52826c7c.svg";
export { ForwardRef as ReactComponent };